import Team from "./gql/Team";

import { TeamDepth } from "../types";

type SiteData = TeamDepth | { errors: any[] };

export default async function getTeam(id: string): Promise<SiteData> {
    try {
        const res = await fetch(
            process.env.NEXT_PUBLIC_API_URL + '/graphql',
            {
                credentials: 'include',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    query: Team,
                    variables: { id },
                }),
            }
        )
        .then((res) => res.json());

        return res.data.Team;
    } catch (err) {
        console.error(err);
        throw err;
    }
}